import React, {Component} from 'react';
import 'react-accessible-accordion/dist/fancy-example.css';
import '../../../assets/css/accordion-arrow-fancy.css'
import OrderMeals from './orderMealsV3'
import ReviewOrder from './orderedMenu'
import {BeatLoader} from 'react-spinners'
import {convertUTCDateToLocalDate,getOrderMonthYearByStudent, getModuleEnum,
    getAccessLevelByModule,
    convertTwoDecimalPoint} from '../../../server/util';
import {Link} from 'react-router-dom'
import {get, getStudentSchoolInfo} from "../../../server/actionsParent";
import PropTypes from "prop-types";
const modEnum=getModuleEnum();
let meals = [];
let order = [];
let price = '';
let selectedStudentId=0;

function menu_sort(a, b) {
    return new Date(b.postDate).getTime() - new Date(a.postDate).getTime();
}


let date = {};
let mealMonth = '';
let id = ''
let status = ''
let reducedPriceStatus = false;
let studentIsFreeMeal=false;
let studentIsReducePrice=false;
let allergies = ''

class viewMenu extends Component {

    getMealList = (mealList) => {
        meals = mealList;
        let x = "ORDER";
        this.setState({fireRedirect: x});
    };
    review = (selection, totalprice) => {
        order = selection;
        price = totalprice;
        let y = "REVIEW";
        this.setState({fireRedirect: y});
        console.log("State" + this.state.fireRedirect);

    }
    cleanUp = () => {
        sessionStorage.removeItem('Menu')
        sessionStorage.removeItem('Price')
    }

    constructor(props) {
        super(props);
        let _date = new Date();
        this.state = {
            loading: false,
            date:_date,
            menuList: [],
            fireRedirect: "",
            pageNumber: 1,
            meals: [],
            price: 0,
            paidEditPrice:0.00,
            studentData: [],
            cutOffDateTime: '',
            isSideSelect:false,
            extraEnableForCaterer:false,
            canOrderAfterCutoff: '',
            isInstantPayment:false,
            lunchBal:0.00

        }
        this.goBack = this.goBack.bind(this);
        this.getInstantPaymentStatus=this.getInstantPaymentStatus.bind(this);
    }
    getInstantPaymentStatus=()=>{    
        if(sessionStorage.getItem('ROLE')=='ROLE_PARENT'){
            const sId=this.context.router.history.location.state.schoolId;
            return getAccessLevelByModule(modEnum.IPFO,sId) && getAccessLevelByModule(modEnum.APO, sId);
        }else{
            return getAccessLevelByModule(modEnum.IPFO);
        }
    }
    getLunchBal=()=>{
        if(sessionStorage.getItem('ROLE')=='ROLE_PARENT'){
            const bal=this.context.router.history.location.state.lunchBal;
            return parseFloat(convertTwoDecimalPoint(bal,2))
        }else{
            return 0.00;
        }
    }

    componentWillMount = () => {
        window.addEventListener("beforeunload", this.cleanUp)
        id = this.context.router.route.match.params.id;
        selectedStudentId=parseInt(id);
        status = this.context.router.route.match.params.status;
        this.setState({loading: true, 
            isInstantPayment: this.getInstantPaymentStatus(),
        lunchBal:this.getLunchBal()});
        if (status === 0) {
            this.setState({
                fireRedirect: "NONE",
                loading: false
            });
        } else {
            // alert("came here")
            get('/studentUsers/' + id + '?access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                allergies = data.allergies;
                let studentData = data || {};
                studentIsFreeMeal=data.isFreeMealEligible==undefined?false:data.isFreeMealEligible;
                studentIsReducePrice=data.isReducePriceEligible==undefined?false:data.isReducePriceEligible;
                this.setState({lunchBal:data.accBalance||0.00});
                get('/studentUsers/'+studentData._links.self.href.split('/').pop()+'/mealSchool?access_token=').then((response) => {
                    if (!response.ok) {
                        this._addNotificationError();
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then((data) => {
                    // alert("came here")
                    studentData.schoolName = data.schoolName;
                    studentData.mealSchoolId = data._links.self.href.split("/").pop();
                    
                    this.setState({
                            studentData: studentData,
                            loading: false
                        }, () => {
                            this.getMenu()
                        }
                    )
                }).catch(
                    (error) => {
                        console.log('Parent dashboard error', error);
                    }
                );

            }).catch(
                (error) => {
                    console.log('Parent dashboard error', error);
                }
            );
        }
    }
    //          //this.setState({studentsList:nextProps.studentData})
    getMenu = () => {
        //alert(JSON.stringify(this.props.studentData,null,2))
        let cutofftime = '';
        let isSideSelect=false;
        let extraEnableForCaterer=false;
        let canOrderAfterCutoff = ''
        console.log('this.state.date',this.state.date)

        let mmyyyy=sessionStorage.getItem('ROLE')=='ROLE_PARENT'? getOrderMonthYearByStudent(this.props.menuYearMonth,selectedStudentId):this.props.menuYearMonth;
        this.setState({date:new Date(mmyyyy.substr(0,4),parseInt(mmyyyy.substr(4,2))-1,'01')||new Date()})
        date={
            month: ("0" + (parseInt(mmyyyy.substr(4,2)))).slice(-2),
            year:mmyyyy.substr(0,4) 
        } ;
        let yearMonth = mmyyyy;
        let mealList = [];
        // alert("came here")
       // get('/schoolMeals/search/findByYearMonthAndGradesInAndMealSchoolSchoolIdAndIsDelete?yearMonth=' + yearMonth + '&gradesList=' + this.state.studentData.gradeName + '&mealSchoolId=' + this.state.studentData.mealSchoolId + '&isDelete=0&access_token=').then((response) => {
        get('/mealSummaryDetails?menuSummaryId=0&mealSchoolId=' + this.state.studentData.mealSchoolId+'&yearMonth=' + yearMonth + '&grade=' + this.state.studentData.gradeName+ '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log('Got School Meals', data);
            if (data.menuItemsList.length === 0) {
                let x = "NONE";
                this.setState({
                    fireRedirect: x,
                    loading: false
                })
            }
            else {
                cutofftime = data.cutOffDatetime;
                isSideSelect=data.isSideSelect;
                extraEnableForCaterer=data.extraEnableForCaterer;
                canOrderAfterCutoff = data.orderDateExtensionStatus;
                reducedPriceStatus = (this.state.studentData||{}).isReducePriceEligible||false;  
                studentIsReducePrice=(this.state.studentData||{}).isReducePriceEligible||false;
                studentIsFreeMeal=(this.state.studentData||{}).isFreeMealEligible||false;
                data.menuItemsList.forEach(x => {
                    let item = {};
                    item.id = x.id;
                    item.title = x.name;
                    item.mealCalendarId=x.mealCalendarId;
                    item.type = x.type;
                    if (x.start !== null) {
                        let parts = x.start.split(/[T]/)
                        let part2 = parts[0].split('-')
                        item.start = (new Date(part2[0], part2[1] - 1, part2[2], 0, 0, 0));
                    } else {
                        item.start = convertUTCDateToLocalDate(new Date(x.start));

                    }

                    item.desc = x.desc;
                    item.price = x.price;
                    item.reducedPrice = x.reducedPrice||0;
                    if (x.type === "MEAL") {
                        item.isSelected = false;
                    }
                    mealList.push(item);
                });

                //TO DO: If want to order for prev month, orderstatus true is always checked for next month, below api goes 404 and loading true

                if (status === "update") {
                    //  alert(this.props.studentData.orderStatus)
                    let studentId = this.state.studentData._links.studentUser.href.split('/').pop();
                    let price=0.00;
                    let x = "ORDER"
                    get('/orderedMealsInfo?studentRecId='+studentId+'&yearMonth='+yearMonth+'&access_token=').then(resp=>{
                        if (!resp.ok) {
                            throw Error(resp.statusText);
                        }
                        return resp.json();
                    }).then(data=>{
                        if(data){                            
                            let _redPrice=0;
                            let _totPrice=0;
                            mealList.map((item,i)=>{
                                if((data.mealCalendarIds||[]).includes(item.mealCalendarId) ){
                                    if(item.type === "MEAL"){
                                    mealList[i].isSelected = true;
                                    _redPrice=_redPrice+item.reducedPrice||0;
                                    _totPrice=_totPrice+item.price||0;
                                    } else if (item.type === 'SIDE'){
                                        if(isSideSelect){
                                            mealList[i].isSelected = true;
                                        }
                                        if(extraEnableForCaterer){
                                            mealList[i].extraEnableForCaterer=true
                                        }
                                    }
                                }
                            });
                            if(studentIsFreeMeal){
                                price=0;
                            }
                            else if(studentIsReducePrice && reducedPriceStatus){
                                price=_redPrice;
                            }
                            else{
                                price=_totPrice;
                            }

                            this.setState({
                                canOrderAfterCutoff: canOrderAfterCutoff,
                                cutOffDateTime: cutofftime,
                                isSideSelect:isSideSelect,
                                extraEnableForCaterer:extraEnableForCaterer,
                                meals: mealList,
                                price: price,
                                paidEditPrice:price,
                                loading: false,
                                fireRedirect: x
                            })
                        }else{
                            this.setState({
                                canOrderAfterCutoff: canOrderAfterCutoff,
                                cutOffDateTime: cutofftime,
                                isSideSelect:isSideSelect,
                                extraEnableForCaterer:extraEnableForCaterer,
                                meals: mealList,
                                price: price,
                                paidEditPrice:price,
                                loading: false,
                                fireRedirect: x
                            })
                        }

                    }).catch(
                        (error) => {
                            console.log('Get Order History response', error)
                            this.setState({
                                canOrderAfterCutoff: canOrderAfterCutoff,
                                cutOffDateTime: cutofftime,
                                isSideSelect:isSideSelect,
                                extraEnableForCaterer:extraEnableForCaterer,
                                meals: mealList,
                                price: price,
                                paidEditPrice:price,
                                loading: false,
                                fireRedirect: x
                            })
                        });
                } else {
                    let x = "ORDER"
                    this.setState({
                        canOrderAfterCutoff: canOrderAfterCutoff,
                        cutOffDateTime: cutofftime,
                        isSideSelect:isSideSelect,
                        extraEnableForCaterer:extraEnableForCaterer,
                        meals: mealList,
                        fireRedirect: x,
                        loading: false
                    })
                }
                //  this.props.getMealList(mealList);
                console.log(JSON.stringify(mealList, null, 2))
            }
        })
        .catch(
            (error) => {
                this.setState({
                    loading: false
                })
                console.log('Get Meal Menu response', error)
            });

        //  this.setState({menuList: menuData});


    };
    componentWillUnmount = () => {
        this.cleanUp();
        window.removeEventListener('beforeunload', this.cleanUp); // remove the event handler for normal unmounting
    }



    goBack() {
        let y = "ORDER";
        this.setState({fireRedirect: y});
    }

    // componentWillReceiveProps=(nextProps)=>{
    //      alert("View Menu"+JSON.stringify(nextProps.studentData,null,2))

    render() {
        console.log(date);

        return (

            <section className="full-width clearfix">
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container " style={{    marginTop: '12px'}}>
                    <div>
                        {this.state.fireRedirect === "NONE" &&
                        <div className="text-center"
                             style={{margin: '30px'}}> School has not added a new menu yet. Please come back
                            later.<br/><Link to="/parent">Back to home</Link></div>}
                        {this.state.fireRedirect === "ORDER" &&
                        <OrderMeals review={this.review} 
                            mealList={this.state.meals}
                            studentData={this.state.studentData} price={this.state.price}
                            mealMonth={date} 
                            cutoff={this.state.cutOffDateTime}
                            isSideSelect={this.state.isSideSelect}
                            extraEnableForCaterer={this.state.extraEnableForCaterer}
                            canOrderAfterCutoff={this.state.canOrderAfterCutoff} allergies={allergies}
                            reducedPriceStatus={reducedPriceStatus}
                            studentIsFreeMeal={studentIsFreeMeal} 
                            studentIsReducePrice={studentIsReducePrice}
                            />}
                        {this.state.fireRedirect === "REVIEW" &&
                        <ReviewOrder paidEditPrice={this.state.paidEditPrice||0.00} order={order} price={price}
                            studentData={this.state.studentData}
                            mealMonth={date} back={this.goBack} 
                            reducedPriceStatus={reducedPriceStatus}
                            isSideSelect={this.state.isSideSelect}
                            extraEnableForCaterer={this.state.extraEnableForCaterer}
                            studentIsFreeMeal={studentIsFreeMeal} 
                            studentIsReducePrice={studentIsReducePrice}
                            instantPayment={this.state.isInstantPayment}
                            lunchBal={this.state.lunchBal}
                            />}                       
                    </div>
                </div>
            </section>
        );
    }
}

viewMenu.contextTypes = {
    router: PropTypes.object.isRequired
}

export default viewMenu;


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/viewMenu.js